import { Component, OnInit, Input } from '@angular/core';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js/auto';
Chart.register(ChartDataLabels);
@Component({
  selector: 'app-dashboard-chart-dialog',
  templateUrl: './dashboard-chart-dialog.component.html',
  styleUrls: ['./dashboard-chart-dialog.component.scss']
})
export class DashboardChartDialogComponent implements OnInit {
  @Input() chartData: any;
  @Input() chartOptions: any;
  @Input() chartTitle :any
  @Input() chartType: string = '';
  @Input() chartLabels: string[] = [];
  @Input() selectedCustomer: string[] = [];
  @Input() startYear:any;
  @Input() endYear:any;
  @Input() selectedDataType:any;
  @Input() selectedTotalSalesCustomer:any;
  @Input() selectedTotalAnnualSalesCustomer:any;

  peakMonth: { month: string, value: number } | null = null;
  lowestMonth: { month: string, value: number } | null = null;

  constructor() {}

  ngOnInit(): void {
    this.calculatePeaksAndLows();
  }

  calculatePeaksAndLows(): void {
    if (!this.chartData || !this.chartData.datasets || !this.chartLabels) return;

    let maxValue = -Infinity;
    let minValue = Infinity;
    let peakMonth = '';
    let lowestMonth = '';

    this.chartData.datasets.forEach((dataset: any) => {
      dataset.data.forEach((value: number, index: number) => {
        const month = this.chartLabels[index] || 'Unknown';
        if (value > maxValue) {
          maxValue = value;
          peakMonth = `${month} (${dataset.label})`;
        }
        if (value < minValue && value > 0) {
          minValue = value;
          lowestMonth = `${month} (${dataset.label})`;
        }
      });
    });

    this.peakMonth = maxValue !== -Infinity ? { month: peakMonth, value: maxValue } : null;
    this.lowestMonth = minValue !== Infinity ? { month: lowestMonth, value: minValue } : null;
  }
}